import { useEffect, useState } from "react";
import { Event, emptyEvent } from "../../../interfaces/event";
import { Media } from "../../../interfaces/media";
import { getEventSingle } from "../../../services/event";
import { useParams } from "react-router-dom";
import { LoadingSpinner } from "../../general/loading-spinner";
import { Col, Row } from "react-bootstrap";
import { t } from "i18next";

export function EventView() {
    const params: any = useParams();

    const [media, setMedia] = useState<Media[]>([]);
    const [loaded, setLoaded] = useState(false);
    const [event, setEvent] = useState<Event>(emptyEvent);

    useEffect(() => {
        getEventSingle(params.id)
            .then(response => {
                setEvent(response.data);
                setMedia(response.data.documents.map((m: Media) => {
                    return m;
                }));
                setLoaded(true);
            })
            .catch(error => {
                console.log(error);
            });
    }, []);

    const handleMediaEventUpload = (media: Media[]) => {
        const newMedia = media.map((m: Media) => { return m; });
        setMedia(newMedia);
    }
    
    return (
        <div className="event-view-container"> 
            <div className="inner">
            { !loaded && 
                <LoadingSpinner />
            }
            { loaded && 
                <h1>{ event.name }</h1>
            }
            { loaded &&
                <div className="event-view">
                    <Row>
                        <Col xs={12} lg={6}>
                            <div className="event-data">
                                { event.description.length > 0 &&
                                    <div className="description">
                                        { event.description }
                                    </div>
                                }
                                { event.date_description.length > 0 &&
                                    <div className="date-description">
                                        <i className="bi bi-calendar-check"></i> { event.date_description }
                                    </div>
                                }
                                { event.venue_name.length > 0 &&
                                    <div className="venue">
                                        { event.venue_name }
                                        { event.venue_link.length > 0 &&
                                            <a href={ event.venue_link } target="_blank" title={ "+ info" }>
                                                <i className="bi bi-arrow-right-circle"></i>
                                            </a>
                                        }
                                    </div>
                                }
                            </div>
                        </Col>
                        <Col xs={12} lg={6}>
                            { event.documents.length > 0 &&
                                <div className="documents-list">
                                    <h4>{ t("Documents") }</h4>
                                    <ul>
                                        { event.documents.map((d: Media) => {
                                            return <li>
                                                <a href={ d.url } title={ d.name } target="_blank">
                                                    { d.name }
                                                </a>
                                            </li>
                                        })}
                                    </ul>
                                </div>
                            }
                        </Col>
                    </Row>
                </div>
            }
            </div>
        </div>
    );
}